import timeZones from '@/constants/timeZones';
import IBusinessHours, { IBusinessHour, IDayID } from '@/types/BusinessHours';
import ITimeZone from '@/types/ITimeZone';
import { Accordion, FormControl, FormLabel, Select } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import DaySelector from './components/DaySelector/DaySelector';

interface BusinessHoursProps {
	className?: string;
	businessHours: IBusinessHours;
	onAddClick: (id: IDayID) => void;
	onDeleteClick: (id: IDayID, index: number) => void;
	onStartChange: (id: IDayID, index: number, value: string) => void;
	onEndChange: (id: IDayID, index: number, value: string) => void;
	onTimeZoneChange: (value: ITimeZone) => void;
	onCopyToAllClick: (intervals: IBusinessHour[]) => void;
	hideTimezoneSelector?: boolean;
	hideLabel?: boolean;
	isLoading?: boolean;
}

export default function BusinessHours(props: BusinessHoursProps) {
	const { t } = useTranslation(); // TODO: Do not reload translation every time

	// TODO: Sort this based on L10N
	const DAY_KEYS: IDayID[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

	return (
		<div className={props.className}>
			<Accordion allowToggle>
				{DAY_KEYS.map((key) => {
					return (
						<DaySelector
							key={key}
							intervals={props.businessHours.weekly[key]}
							id={key}
							onDeleteClick={props.onDeleteClick}
							onAddClick={props.onAddClick}
							onStartChange={props.onStartChange}
							onEndChange={props.onEndChange}
							onCopyToAllClick={props.onCopyToAllClick}
							isLoading={props.isLoading}
						/>
					);
				})}
			</Accordion>
			{props.hideTimezoneSelector === true ? null : (
				<FormControl id="timeZone" mt={4} isDisabled={props.isLoading}>
					<FormLabel>{t('TimeZone')}</FormLabel>
					<Select
						isDisabled={props.isLoading}
						value={props.businessHours.timeZone}
						onChange={(e) => props.onTimeZoneChange(e.target.value)}
					>
						{timeZones.map((timezone) => (
							<option key={timezone} value={timezone}>
								{timezone}
							</option>
						))}
					</Select>
				</FormControl>
			)}
		</div>
	);
}
